module.exports = __webpack_public_path__ + "static/amg-logo-full-b44c462f6a4fde92a202049c3667e570.svg";